export default {
  fn: (value) => value && value.toLowerCase().match(/\.(?:jpg|gif|png|bmp|jpeg)/g),
  message: 'Please choose a valid image file'
};
